<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="viewedByOwner" dark icon title="View in My Attendance" @click="viewInMyAttendance">
                        <v-icon>access_time</v-icon>
                    </v-btn>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                    <div v-if="!loading&&hasEditAndApprover">
                        <v-menu left v-model="menu_status" offset-y :disabled="frozenPeriod||closedPeriod||approved_Timesheet"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(overtime_details.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(overtime_details.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense >
                                <v-list-tile v-show="created_status||rejected_status" :key="0" @click="showEditOvertime" title="Edit Overtime">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="created_status" :key="1" @click="setForReview" title="Set to For Review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="created_status||rejected_status" :key="2" @click="dialogDelete=true" title="Delete Overtime">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile dense v-show="forReview_status||approved_status" :key="3" @click="reject" title="Reject Overtime">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile dense v-show="forReview_status||rejected_status" :key="4" @click="approve" title="Approve Overtime">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>  
                            </v-list>
                        </v-menu>
                    </div>
                    <div v-if="!loading&&!hasEditAndApprover">
                        <v-menu v-if="hasEditRights" left v-model="menu_status" offset-y :disabled="frozenPeriod||closedPeriod||approved_Timesheet||approved_status||forReview_status||deleted_status"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(overtime_details.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(overtime_details.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="created_status||rejected_status" :key="0" @click="dialogDelete=true" title="Delete Overtime">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="created_status||rejected_status" :key="1" @click="showEditOvertime" title="Edit Overtime">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="created_status" :key="2" @click="setForReview" title="Set to For Review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-menu v-if="hasApproverRights" left v-model="menu_status" offset-y :disabled="created_status||frozenPeriod||closedPeriod||approved_Timesheet||deleted_status">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(overtime_details.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(overtime_details.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="forReview_status||rejected_status" :key="0" @click="approve" title="Approve Overtime">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="forReview_status||approved_status" :key="1" @click="reject" title="Reject Overtime">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-btn v-if="!hasEditRights&&!hasApproverRights" :color="commonfn.getStatusButtonColor(overtime_details.status)" dark>
                            {{commonfn.getStatusDescription(overtime_details.status)}}
                        </v-btn>
                    </div>
                </v-toolbar>
            </v-card>
            <v-alert v-if="!loading && approved_Timesheet" :value="true" color="warning" icon="warning" outline style="margin-top:5px;">
                The timesheet for this period is already <b>Approved</b>. You will not be able to change this record.
            </v-alert>

            <!-- details -->
            <v-card v-if="!loading && overtime_details"  style="margin-top:5px;margin-bottom:5px;" class="elavation-1">
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold">Overtime Details</span>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="black"></help-link>
                </v-toolbar>
                <v-layout row wrap> 
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Requested By :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <v-chip @click="viewUserProfile(overtime_details, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(overtime_details.userId)"></v-img>
                                    </v-avatar>
                                    {{overtime_details.firstName}} {{overtime_details.lastName}}
                                </v-chip>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Date :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.transDate|moment('dddd, DD MMM YYYY')}}
                            </v-flex>  
                        </v-layout> 
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Duration :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.startTime|moment('hh:mm a')}} - {{overtime_details.endTime|moment('hh:mm a')}}
                            </v-flex>  
                        </v-layout>   
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Total Hours :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.hoursStr}}
                            </v-flex>    
                        </v-layout>      
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Break Time :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.breakTime}} minutes
                            </v-flex>  
                        </v-layout>         
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Chargeable Hours :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.chargeableHours}}
                            </v-flex>  
                        </v-layout>   
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Project Task :
                            </v-flex>
                            <v-flex xs8 class="text-xs-left">
                                <b v-if="overtime_details.projectTaskKey">{{overtime_details.projectTaskKey}} : {{overtime_details.taskName}}</b>
                                <i v-else>(Not specified)</i>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Charging : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="overtime_details.offsetOrPay==1">Offset</span>
                                <span v-else>Payroll</span>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Rate : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{ overtimeRateDescription }}
                            </v-flex>  
                        </v-layout>
                        <v-layout v-if="overtime_details.remarks" row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Remarks : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{overtime_details.remarks}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <!-- updates history component -->
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedOvertimeId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogDelete" width="500">
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Confirm Delete</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p>Delete this Overtime request?</p>
                    <p>Note: you will not be able to undo this operation.</p>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn title="Delete" class="red" dark @click="deleteOvertime" :loading="loading_delete">Delete</v-btn>
                    <v-btn title="Cancel" @click="dialogDelete=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogOvertime" width="600" persistent>   
            <overtime ref="overtimeRef" @send="getOvertime(false)" :dialogOvertime.sync="dialogOvertime"></overtime>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedOvertimeId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>

<script>

import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'
import myTeamsPermissions from '@/helpers/myteams-permissions'
import AppPageID from '@/constants/app_page_ids'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import OvertimeRateType from '@/constants/overtime-rate-types'

export default {     
    name: 'OvertimeDetails',
    metaInfo: {
        title: 'Overtime Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Overtime Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'overtime': () => import('@/components/Attendance/Overtime'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_status: false,
            menu_status: false,
            message: null,
            dialogDelete: false,
            cutoff_details: null,
            overtime_details: null,
            dialogOvertime:false
        }
    },
    methods: {  
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.approve(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.forReview(data)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.reject(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getOvertime(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        showEditOvertime() {
            var data = {
                mode: 'Edit',
                transDate: this.overtime_details.transDate,
                overtimeId: this.overtime_details.overtimeId,
                projectId: this.overtime_details.projectId,
                projectTaskId: this.overtime_details.projectTaskId,
                breakTime: this.overtime_details.breakTime,
                hours: this.overtime_details.hours,
                startTime: this.overtime_details.startTime,
                endTime: this.overtime_details.endTime,
                status: this.overtime_details.status,
                offsetOrPay: this.overtime_details.offsetOrPay,
                // premiumOnly: this.overtime_details.premiumOnly,
                rateType: this.overtime_details.rateType,
                updatedBy: this.overtime_details.updatedBy,
                updatedByName: this.overtime_details.updatedByName,
                updatedByRemarks: this.overtime_details.updatedByRemarks,
                remarks: this.overtime_details.remarks
            }
            this.$refs.overtimeRef.setParams(data)
            this.dialogOvertime = true
        },
        async deleteOvertime() {
            try {
                this.loading_delete = true
                var data = {
                    overtimeId: this.overtime_details.overtimeId
                }
                const response = await overtimeApi.delete(data)
                if (response && response.status == 200) {
                    this.loading_delete = false
                    this.dialogDelete = false
                    this.$router.push(`/myattendance/overtime/${this.overtime_details.cutoffId}`)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewInMyAttendance() {
            this.$router.push(`/myattendance/daily/${this.$moment(this.overtime_details.transDate).format('YYYY-MM-DD')}`)
        },
        getWorkshiftType(strict) {
            if (strict) return '(Strict Shift)'
            return '(Flexible Shift)'
        },
        async getOvertime(show_loading) {
            try {
                if (show_loading) this.loading = true
                const response = await overtimeApi.getById(this.selectedOvertimeId, this.userPageKey)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.overtime_details = response.data.overtimeItem
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getOvertime(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        this.commonfn = commonfn
        this.awsS3Helper = awsS3Helper
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Overtime Details'
        })

        this.getOvertime(true)
    },
    computed: {
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path) ||
                myTeamsPermissions.hasTeamEditRights(AppPageID.TeamOvertime)
        },
        hasApproverRights() {
            return myTeamsPermissions.hasTeamApproverRights(AppPageID.TeamOvertime)            
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasApproverRights
        },
        selectedOvertimeId() {
            return this.$route.params.overtimeId
        },
        viewedByOwner() {
            if (this.overtime_details)
                return this.$store.state.userId == this.overtime_details.userId
        },
        userPageKey() {
            if (this.$router.currentRoute.path.includes('company/overtime')) {
                return pageKeys.overtime_company_approver
            }else if (this.$router.currentRoute.path.includes('myteam/overtime')) {
                return pageKeys.overtime_team_approver
            }else{
                return pageKeys.overtime
            }
        },
        pageLink() {
            if (this.overtime_details) {
                if (this.viewedByOwner) {
                    if (this.$router.currentRoute.path.includes('company/overtime')) {
                        return `company${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }else{
                        return `myteam${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }
                }else{
                    return `myattendance${this.$router.currentRoute.path.replace('/myteam','').replace('/company','')}`
                }
            }
        },
        commentsData() {
            if (this.overtime_details) {
                return {
                    pageQueryId: this.selectedOvertimeId,
                    pageItemCreatedBy: this.overtime_details.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.overtime_team_approver,
                    notificationTypeId: notificationTypes.overtime
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        frozenPeriod(){
            if (this.cutoff_details) {
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
            }
        },
        closedPeriod(){
            if (this.cutoff_details) {
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
            }
        },
        deleted_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Deleted')
            }
        },
        created_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Created')
            }
        },
        forReview_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('For Review')
            }
        },
        approved_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Approved')
            }
        },
        rejected_status() {
            if (this.overtime_details) {
                return this.overtime_details.status==commonfn.getStatusCode('Rejected')
            }
        },
        approved_Timesheet() {
            if (this.cutoff_details) {
                return this.cutoff_details.timeReportStatus==commonfn.getStatusCode('Approved')
            } 
        },
        helpPageId() {
            if (this.viewedByOwner) {
                return 'overtime-page'
            }else{
                if (this.$router.currentRoute.path.includes('company')) {
                    return 'overtime-review-company'
                }else{
                    return 'overtime-review-team'
                }
            }
        },
        overtimeRateDescription() {
            if (this.overtime_details) {
                return OvertimeRateType.find(x => x.rateType == this.overtime_details.rateType).description
            }
        }
    }
}
</script>